{
  "login": {
    "genericError": "Beim Anmelden ist ein Fehler aufgetreten. Bitte versuche es erneut."
  },
  "acceptTerms": {
    "pleaseAccept": "Bitte akzeptiere die Nutzungsbedingungen, um fortzufahren",
    "accepted": "Nutzungsbedingungen akzeptiert",
    "failedGeneric": "Nutzungsbedingungen konnten nicht akzeptiert werden. Bitte versuche es erneut."
  },
  "discord": {
    "linkSuccess": "Discord-Konto verknüpft! Bitte verifiziere deine DMs unten.",
    "linkFailed": "Discord-Konto konnte nicht verknüpft werden: {{message}}",
    "verificationSent": "Bestätigungscode an deine Discord-DMs gesendet!",
    "dmVerified": "Discord-DMs erfolgreich verifiziert! Benachrichtigungen sind jetzt verfügbar.",
    "settingToggled": "{{label}} {{state}}",
    "unlinked": "Discord-Konto erfolgreich getrennt!",
    "userIdNotFound": "Benutzer-ID nicht gefunden. Bitte versuche dich erneut anzumelden.",
    "clientIdNotConfigured": "Discord-Client-ID nicht konfiguriert. Überprüfe deine Umgebungsvariablen.",
    "redirectUriNotConfigured": "Umleitungs-URL nicht korrekt konfiguriert. Überprüfe deine Umgebungsvariablen.",
    "allowPopups": "Bitte erlauben Sie Popups für diese Seite, um Ihr Discord-Konto zu verknüpfen",
    "linkFirst": "Bitte verknüpfe zuerst dein Discord-Konto",
    "sendCodeFailed": "Verifizierungscode konnte nicht gesendet werden. Stelle sicher, dass der Bot dir DMs senden kann.",
    "sendCodeFailedGeneric": "Verifizierungscode konnte nicht gesendet werden",
    "enterCode": "Bitte gib den Verifizierungscode ein",
    "verifyCodeFailed": "Code konnte nicht verifiziert werden. Bitte versuche es erneut.",
    "verifyFirst": "Bitte verifiziere zuerst deine Discord-DMs",
    "updateSettingFailed": "Benachrichtigungseinstellung konnte nicht aktualisiert werden",
    "unlinkFailed": "Discord-Konto konnte nicht getrennt werden",
    "categoryUpdated": "Kategorie aktualisiert",
    "categoryUpdateFailed": "Kategorie konnte nicht aktualisiert werden",
    "categoryDeleted": "Kategorie gelöscht",
    "categoryDeleteFailed": "Kategorie konnte nicht gelöscht werden",
    "defaultCategoryUpdated": "Standardkategorie aktualisiert",
    "setDefaultFailed": "Standardkategorie konnte nicht festgelegt werden",
    "categoryCreated": "Kategorie erstellt",
    "categoryCreateFailed": "Kategorie konnte nicht erstellt werden"
  },
  "subscription": {
    "failedLoadPricing": "Preisinformationen konnten nicht geladen werden",
    "failedCheckout": "Checkout konnte nicht gestartet werden",
    "failedChangeSubscription": "Abonnement konnte nicht geändert werden",
    "failedOpenBillingPortal": "Abrechnungsportal konnte nicht geöffnet werden",
    "cancelSuccess": "Dein Abonnement wurde erfolgreich gekündigt",
    "cancelFailed": "Abonnement konnte nicht gekündigt werden",
    "resumeSuccess": "Dein Abonnement wurde erfolgreich fortgesetzt",
    "resumeFailed": "Abonnement konnte nicht fortgesetzt werden",
    "updateSuccess": "Dein Abonnement wurde aktualisiert!",
    "newSubscriptionSuccess": "Willkommen! Dein Abonnement ist jetzt aktiv."
  },
  "trial": {
    "activated": "Testzeitraum aktiviert! Geniesse 7 Tage FlippingPal.",
    "activationFailed": "Der Testzeitraum konnte nicht aktiviert werden"
  },
  "account": {
    "emailBothFieldsRequired": "Bitte fülle beide Felder aus",
    "emailInvalid": "Bitte gib eine gültige E-Mail-Adresse ein",
    "emailUpdated": "E-Mail aktualisiert! Bitte überprüfe deine neue E-Mail Adresse zur Bestätigung. Abmeldung läuft...",
    "emailFailed": "E-Mail Adresse konnte nicht geändert werden",
    "passwordAllFieldsRequired": "Bitte fülle alle Passwortfelder aus",
    "passwordTooShort": "Das neue Passwort muss mindestens 4 Zeichen lang sein",
    "passwordsDoNotMatch": "Die neuen Passwörter stimmen nicht überein",
    "passwordChanged": "Passwort erfolgreich geändert!",
    "passwordFailed": "Passwort konnte nicht geändert werden",
    "closeAccountPasswordRequired": "Bitte gib dein Passwort ein",
    "closeAccountConfirmRequired": "Bitte tippe \"KONTO SCHLIESSEN\" zur Bestätigung ein",
    "accountClosed": "Konto geschlossen. Abmeldung läuft...",
    "closeAccountFailed": "Konto konnte nicht geschlossen werden"
  },
  "snipe": {
    "ilvlEnterAtLeastOne": "Bitte gib mindestens ein Min-ilvl oder Max-ilvl ein",
    "ilvlValidMin": "Bitte gib ein gültiges Min-ilvl ein",
    "ilvlValidMax": "Bitte gib ein gültiges Max-ilvl ein",
    "ilvlMinExceedsMax": "Min-ilvl darf {{max}} nicht überschreiten",
    "ilvlMaxExceedsMax": "Max-ilvl darf {{max}} nicht überschreiten",
    "ilvlMinGreaterThanMax": "Min-ilvl darf nicht grösser als Max-ilvl sein",
    "ilvlValidPrice": "Bitte gib einen gültigen Preis ein (z.B. 100g, 50g 30s oder 100)",
    "reqLvlMinRange": "Das erforderliche Min-Level muss zwischen {{min}} und {{max}} liegen",
    "reqLvlMaxRange": "Das erforderliche Max-Level muss zwischen {{min}} und {{max}} liegen",
    "reqLvlMinGreaterThanMax": "Das erforderliche Min-Level darf nicht grösser als das erforderliche Max-Level sein",
    "ilvlAdded": "ilvl-Snipe hinzugefügt",
    "ilvlUpdated": "ilvl-Snipe aktualisiert",
    "ilvlSaveFailed": "ilvl-Snipe konnte nicht gespeichert werden",
    "ilvlRemoved": "ilvl-Snipe entfernt",
    "ilvlRemoveFailed": "ilvl-Snipe konnte nicht entfernt werden",
    "selectItem": "Bitte wähle einen Gegenstand aus",
    "validPetId": "Bitte gib eine gültige Haustier-ID ein oder suche nach einem Haustier",
    "invalidPrice": "Bitte gib einen gültigen Preis ein (z.B. 100g, 50g 30s oder 100)",
    "itemAdded": "Snipe-{{label}} hinzugefügt",
    "itemUpdated": "Snipe-{{label}} aktualisiert",
    "itemAddFailed": "Snipe-{{type}} konnte nicht hinzugefügt werden",
    "itemRemoved": "Snipe-{{type}} entfernt",
    "itemRemoveFailed": "Snipe-{{type}} konnte nicht entfernt werden",
    "editingWoWToken": "WoW-Token-Snipe-Benachrichtigung wird bearbeitet",
    "editingSnipeAlert": "Snipe-Benachrichtigung für {{name}} wird bearbeitet",
    "itemNotFound": "{{label}} nicht gefunden.",
    "importInvalidArrayFormat": "Ungültiges Format. Es wird ein Array von ilvl-Snipe-Regeln erwartet.",
    "importNoValidEntries": "Keine gültigen Einträge gefunden. Array-Elemente benötigen die Felder \"{{idKey}}\" und \"price\".",
    "importInvalidJsonFormat": "Ungültiges JSON-Format. Erwartet wird { {{idKey}}: goldPreis, ... } oder ein Array von Objekten.",
    "importSuccess": "Import: {{added}} hinzugefügt, {{updated}} aktualisiert, {{skipped}} übersprungen",
    "importIlvlSuccess": "{{count}} ilvl-Snipe-Regel(n) importiert",
    "importParseFailed": "JSON konnte nicht geparst oder importiert werden",
    "noItemsToExport": "Keine {{type}} zum Exportieren",
    "noIlvlItemsToExport": "Keine ilvl-Gegenstände zum Exportieren",
    "exportSuccess": "{{count}} {{type}} exportiert",
    "exportIlvlSuccess": "{{count}} ilvl-Gegenstände exportiert",
    "enabledToggle": "Snipe-Benachrichtigungen {{state}}",
    "enabledToggleFailed": "Snipe-Einstellung konnte nicht aktualisiert werden",
    "alertStyleUpdated": "Benachrichtigungsstil auf {{style}} gesetzt",
    "alertStyleFailed": "Benachrichtigungsstil konnte nicht aktualisiert werden",
    "realmsSaved": "Snipe-Server gespeichert",
    "realmsSaveFailed": "Snipe-Server konnten nicht gespeichert werden",
    "clearAllConfirm": "Bist du sicher, dass du alle Snipe-{{label}} entfernen möchtest?",
    "clearAllSuccess": "Alle Snipe-{{label}} gelöscht",
    "clearAllFailed": "Snipe-{{label}} konnten nicht gelöscht werden",
    "cooldownCyclesUpdated": "Benachrichtigungs-Cooldown auf {{cycles}} übersprungene Zyklen gesetzt",
    "cooldownCyclesFailed": "Fehler beim Aktualisieren des Cooldowns",
    "cooldownCyclesInvalid": "Der Cooldown muss zwischen 0 und 24 Zyklen liegen",
    "undo": "Rückgängig",
    "undoRestored": "Snipe-Alarm wiederhergestellt",
    "undoFailed": "Snipe-Alarm konnte nicht wiederhergestellt werden",
    "priceUpdated": "Preis aktualisiert",
    "priceUpdateFailed": "Preis konnte nicht aktualisiert werden"
  },
  "personalConfig": {
    "saveSuccess": "Filter-Standards erfolgreich gespeichert!",
    "saveFailed": "Filter-Standards konnten nicht gespeichert werden"
  },
  "auth": {
    "registrationSuccessEmail": "Registrierung erfolgreich! Bitte überprüfe deine E-Mail zur Bestätigung.",
    "registrationSuccessLogin": "Registrierung erfolgreich! Bitte melde dich mit deinem neuen Konto an.",
    "passwordResetSuccess": "Passwort erfolgreich zurückgesetzt"
  },
  "common": {
    "networkError": "Netzwerkfehler. Bitte versuche es erneut."
  },
  "validation": {
    "passwordRequired": "Passwort ist erforderlich",
    "passwordMinLength": "Das Passwort muss mindestens {{count}} Zeichen lang sein",
    "passwordUppercase": "Das Passwort muss mindestens einen Grossbuchstaben enthalten",
    "passwordLowercase": "Das Passwort muss mindestens einen Kleinbuchstaben enthalten",
    "passwordNumber": "Das Passwort muss mindestens eine Ziffer enthalten",
    "passwordSpecialChar": "Das Passwort muss mindestens ein Sonderzeichen enthalten",
    "confirmPasswordRequired": "Bitte bestätige dein Passwort",
    "passwordsDoNotMatch": "Passwörter stimmen nicht überein",
    "emailRequired": "E-Mail ist erforderlich",
    "emailInvalid": "Bitte gib eine gültige E-Mail-Adresse ein"
  },
  "filterPreset": {
    "fetchFailed": "Filter-Voreinstellungen konnten nicht geladen werden",
    "createFailed": "Filter-Voreinstellung konnte nicht erstellt werden",
    "updateFailed": "Filter-Voreinstellung konnte nicht aktualisiert werden",
    "deleteFailed": "Filter-Voreinstellung konnte nicht gelöscht werden",
    "invalidImportNotObject": "Ungültiger Import-String: Kein gültiges Voreinstellungsobjekt",
    "invalidImportMissingVersion": "Ungültiger Import-String: Versionsinformation fehlt",
    "invalidImportMissingPreset": "Ungültiger Import-String: Voreinstellungsdaten fehlen",
    "invalidPresetMissingName": "Ungültige Voreinstellung: Name fehlt oder ist ungültig",
    "invalidPresetMissingFilters": "Ungültige Voreinstellung \"{{name}}\": Filter fehlen oder sind ungültig"
  }
}
